module.exports = __webpack_public_path__ + "img/unload-2-1.eec0aac7.png";